/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import routeGenerators from 'ui/common/routes/generators';
import ProgressBar from 'ui/common/rebranding/components/ProgressBar';
import ProgressChart from 'ui/common/charts/progress-chart'; // progress bar and chart are two diff components
import { truncate } from 'utils/string.js';
import themeConfig from 'ui/theme/config';

import { UncontrolledTooltip } from 'reactstrap';
import messages from './messages';
import StartAssignmentBtn from 'ui/graphql/StartAssignmentBtn';
import styles from './index.module.scss';
import indorsedIcon from 'resources/common/indorsed.svg';
import flaggedIcon from 'resources/common/flagged.svg';
import logoMeta from 'resources/brand/logo-icon.png';
import Button from 'ui/common/button';
import Countdown from 'ui/common/countdown/loadable';
import { parseApiDate } from 'store/common/schemas';

import check from './check.svg';
class Assignment extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  renderLabels(type) {
    const { intl: { formatMessage } } = this.props;
    if (type === 'indorsed') {
      return (
        <Button svgIcon={indorsedIcon} iconPosition="prefix" className="cat-health gradient px-4">
          <span className="ml-2">{formatMessage(messages.indorsed)}</span>
        </Button>
      );
    } else if (type === 'flagged') {
      return (
        <Button
          svgIcon={flaggedIcon}
          iconPosition="prefix"
          className="cat-technology gradient px-4"
        >
          <span className="ml-2">{formatMessage(messages.flagged)}</span>
        </Button>
      );
    } else {
      return (
        <Button disabled className={styles.disabledCursor} isReady={false}>
          {formatMessage(messages.pendingValidation)}
        </Button>
      );
    }
  }

  renderClaimStatuses(claim) {
    const {
      intl: { formatMessage },
      onStartAssignmentClick,
      assignment: { _id },
      assessmentMagicLink,
    } = this.props;
    if (claim) {
      const { status, expires_at: expiresAt, votesThreshold, completedVoteCount } = claim;
      const inProgress = status === 'claim_submitted' || status === 'in_progress';
      const showProgressBar = status === 'in_progress' && expiresAt;
      const isFlagged = status === 'rejected' || status === 'no_consensus';
      const isIndorsed = status === 'indorsed';
      const isDisapproved = status === 'claim_disapproved';

      return (
        <div>
          {isDisapproved && (
            <StartAssignmentBtn
              assignmentId={_id}
              enableEndpointCall={true}
              label={formatMessage(messages.retake)}
              onStartAssignmentClick={onStartAssignmentClick}
              userAssessmentId={assessmentMagicLink ? assessmentMagicLink.id : ''}
            />
          )}
          {inProgress && this.renderLabels('pending')}
          {inProgress &&
            showProgressBar && (
              <div className="py-3">
                <ProgressBar
                  min={0}
                  max={votesThreshold}
                  value={completedVoteCount}
                  label="Votes"
                />
              </div>
            )}
          {isIndorsed && <div>{this.renderLabels('indorsed')}</div>}
          {isFlagged && (
            <div className="d-flex flex-column align-items-center align-items-md-end">
              <div>{this.renderLabels('flagged')}</div>
              <div>
                <StartAssignmentBtn
                  className="mt-2"
                  assignmentId={_id}
                  enableEndpointCall={true}
                  label={formatMessage(messages.retake)}
                  onStartAssignmentClick={onStartAssignmentClick}
                  userAssessmentId={assessmentMagicLink ? assessmentMagicLink.id : ''}
                />
              </div>
            </div>
          )}
          {showProgressBar && (
            <div className="d-flex justify-content-end">
              <div>{formatMessage(messages.votingExpiry)}</div>
              <div className="ml-2">
                <b>
                  <Countdown deadline={parseApiDate(expiresAt)} />
                </b>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
  titleClicked(e) {
    e.preventDefault();
    const { assignment, onStartAssignmentClick: onStartAssignmentClickCallback } = this.props;
    if (assignment) {
      if (onStartAssignmentClickCallback) {
        onStartAssignmentClickCallback(assignment._id);
      } else {
        let path = routeGenerators.assignments.details({ assignmentId: assignment._id });
        this.props.history.push(path);
      }
    }
  }

  renderProgressChart(claim) {
    let dataSets = [];

    const { indorsedVotesCount, flaggedVotesCount } = claim;

    if (claim) {
      dataSets = [
        {
          label: 'Recommended',
          value: indorsedVotesCount,
          color: [themeConfig.palette.category.healthA, themeConfig.palette.category.healthB],
        },
        {
          label: 'Not Recommended',
          value: flaggedVotesCount,
          color: [
            themeConfig.palette.category.technologyA,
            themeConfig.palette.category.technologyB,
          ],
        },
      ];
    }

    return (
      <div className="w-100">
        {dataSets &&
          dataSets.length > 0 && (
            <div className={classnames('d-flex pb-3 justify-content-center', styles.progressChart)}>
              <div>
                <ProgressChart labelLegend="Votes" height={70} width={60} dataSets={dataSets} />
              </div>
              <div>
                <ul>
                  {dataSets.map((data, index) => {
                    return (
                      <li className="mt-2 ml-2" key={index}>
                        <p>
                          <span>{data.value} votes</span>
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
      </div>
    );
  }

  render() {
    const {
      assignment,
      onStartAssignmentClick,
      intl: { formatMessage },
      assessmentMagicLink,
    } = this.props;

    if (assignment) {
      const { _id, title, img_url, scope, disabled, lastViewerAssignment, duration } = assignment;

      if (disabled) return null;

      const isStarted = !lastViewerAssignment || lastViewerAssignment.status === 'started';
      const inProgress =
        lastViewerAssignment &&
        lastViewerAssignment.status === 'submitted' &&
        !lastViewerAssignment.claim;
      const hasClaim = lastViewerAssignment && lastViewerAssignment.claim;

      const isIndorsed =
        lastViewerAssignment &&
        lastViewerAssignment.claim &&
        lastViewerAssignment.claim.status === 'indorsed';

      return (
        <div key={_id} className="row justify-content-md-center pb-3">
          <div className={classnames('col-12')}>
            <div
              className={classnames(
                'px-3 border',
                styles.whiteSmokeBorder,
                isIndorsed ? styles.card_border : ''
              )}
            >
              <div className={classnames('row align-items-center p-md-4')}>
                {isIndorsed && (
                  <img
                    className={classnames('position-absolute')}
                    src={check}
                    height="20px"
                    width="20px"
                    alt="checkbox"
                    style={{ top: '1rem', left: '2rem' }}
                  />
                )}
                {/* <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.md}> */}
                <div className="col col-sm-12 col-md-3">
                  <img
                    src={img_url || logoMeta}
                    alt={title}
                    className="mx-auto"
                    width={150}
                    height={150}
                  />
                </div>
                {/* </MediaQuery> */}
                <div className="col-12 col-sm-12 col-md-6">
                  {title && (
                    <h2 className="text-center text-md-left">
                      <a href="#" className={styles.noDecoration} onClick={this.titleClicked}>
                        {title}
                      </a>
                    </h2>
                  )}
                  <p className="py-2">{formatMessage(messages.scopeOfAssignment)}</p>
                  {scope && (
                    <p>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: truncate(scope, 200),
                        }}
                      />
                    </p>
                  )}
                </div>
                <div className="col-12 col-sm-12 py-3 py-md-0 col-md-3">
                  {isIndorsed ? (
                    <div className="d-flex justify-content-center justify-content-md-start">
                      {this.renderProgressChart(lastViewerAssignment.claim)}
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center justify-content-md-end">
                      <div className={styles.duration}>
                        <i className="fa fa-clock-o fa-2x" />
                        <b className="text-center">
                          {formatMessage(messages.durationEstimate)}{' '}
                          <i className="fa fa-question-circle" id="assignment" />
                        </b>

                        <UncontrolledTooltip target="assignment" style={{ width: '100px' }}>
                          This estimated time is only an estimate to complete this challenge. This
                          is not Timed Coding Test.
                        </UncontrolledTooltip>
                        <b>{duration}</b>
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-center justify-content-md-end">
                    {isStarted && (
                      <StartAssignmentBtn
                        assignmentId={_id}
                        enableEndpointCall={!lastViewerAssignment}
                        onStartAssignmentClick={onStartAssignmentClick}
                        userAssessmentId={assessmentMagicLink ? assessmentMagicLink.id : ''}
                      />
                    )}
                    {inProgress && this.renderLabels('pending')}
                    {hasClaim && this.renderClaimStatuses(lastViewerAssignment.claim)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default withRouter(injectIntl(Assignment));
